import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AccessibleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"accessible"}/>
}
